import { createContext } from 'react'

export const EventContext = createContext({
  eventId: null,
  changeEventId: () => {}
})

export const ReadOnlyContext = createContext(false)

export const AccountContext = createContext({
  currentAccountId: null,  // either employer / employergroup node id
  isEmployerGroupAccount: false,
  switchAccount: () => {} 
})



// WEBPACK FOOTER //
// ./src/context.js